<div  class="d-flex flex-column position-relative form-input">
    <label  class="justify-content-start d-flex">{{label}}
      <span *ngIf="mandatory" class="text-danger">*</span>
    </label>
    <div (focusout)="elementFocused()" [ngClass]="{
        'border-danger': isInerrorState
      }">
    <p-dropdown [appendTo]="'body'"  [(ngModel)]="selectedValue"  (focusout)="elementFocused()"   [options]="suggestionList"  (onChange)="onSelect($event)" styleClass="d-flex align-items-center position-relative w-100  input-field" [placeholder]="placeholder" optionValue="value"   optionLabel="value"></p-dropdown>
    </div>
</div>